import { store } from '@/app/store'
import { adminPortalApi } from '@/data/admin/api/admin_portal_api'

export class FaqsRtkDatasource {
  async list() {
    const result = await store.dispatch(adminPortalApi.endpoints.getFaqs.initiate())
    if (result.error) throw result.error
    return result.data ?? []
  }

  async getById(id: string) {
    const result = await store.dispatch(
      adminPortalApi.endpoints.getFaqById.initiate(id)
    )
    if (result.error) throw result.error
    if (!result.data) throw new Error('FAQ not found')
    return result.data
  }

  async create(payload: { question: string; answer: string }) {
    const result = await store.dispatch(
      adminPortalApi.endpoints.createFaq.initiate(payload)
    )
    if (result.error) throw result.error
    return result.data
  }

  async update(payload: { id: string; question: string; answer: string }) {
    const result = await store.dispatch(
      adminPortalApi.endpoints.updateFaq.initiate(payload)
    )
    if (result.error) throw result.error
    return result.data
  }

  async delete(id: string) {
    const result = await store.dispatch(
      adminPortalApi.endpoints.deleteFaq.initiate(id)
    )
    if (result.error) throw result.error
  }
}
